export const environment = {
  production: false,
  apiUrl: 'https://fleetbooster.net/hos',
  auth: {
    domain: 'dev-kfn2hv7ynazqwutc.us.auth0.com',
    clientId: '3dR1sXvMJ3Yg9nmSCTNUZCEdXU8tHyQ3',
    audience: 'https://fleetbooster.net'
  }
};
